import React, { memo } from 'react';
import { PageContainer, Footer, Title, Hero, Header } from '@web/components';
import { NavLink } from 'react-router-dom';
import { TITLE, GDPR_ROUTE, HERO_SIZE } from 'config';
import { PageNavigation, PageLogo, PageUser } from './PageComponents';

const defaultHeight = 140;

export const PageBody: React.FC = memo(() => (
	<>
		<Header
			defaultOpacity={.8}
			maxOpacity={1}
			defaultHeight={defaultHeight}
			minHeight={80}
			logo={<PageLogo height={defaultHeight}/>}
			navigation={PageNavigation}
			user={<PageUser/>}
		/>
		<Hero height={HERO_SIZE}/>
		<Title/>
		
		<PageContainer/>
		
		<Footer copyright={TITLE}>
			<p><NavLink to={GDPR_ROUTE}>Informace o zpracování osobních údajů dle GDPR</NavLink></p>
		</Footer>
	</>
));

